module.exports = __webpack_public_path__ + "img/general.079b1a15.png";